// 다른 창에서 활성 소속(회사)이 바뀌었다는 안내 — 호스트 최상위에서 한 번만 구독한다.
// 요청 헤더의 소속은 매번 저장소를 읽어 새 회사로 나가는데 이 창의 화면(메모리·캐시)은 옛 회사 데이터라서,
// 그대로 저장·확정하면 엉뚱한 회사 장부에 들어간다. 그래서 알리고 새로 고침을 권한다.
// 자동 새로 고침은 하지 않는다 — 입력 중인 내용을 말없이 날리지 않기 위해서다. 모듈 번들은 요청마다 저장소를
// 읽으므로 호스트 한 곳만 구독하면 되고, 이 안내는 닫을 수 없다(닫고 계속 쓰면 어긋난 채로 일하게 된다).
import React, { useEffect, useState } from 'react';
import { AXButton, onActiveAffiliationChange } from 'yukimushi-component-fe';
import { useT } from '../lib/locale';

export default function AffiliationChangedNotice() {
  const { t } = useT();
  const [changed, setChanged] = useState(false);

  useEffect(() => onActiveAffiliationChange(() => setChanged(true)), []);

  if (!changed) return null;
  return (
    <div
      role="alert"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 3000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, flexWrap: 'wrap',
        padding: '10px 16px', background: '#fff4e5', borderBottom: '1px solid #f0b86e', color: '#5a3b00',
        boxShadow: '0 2px 6px rgba(0,0,0,.15)',
      }}
    >
      <div style={{ minWidth: 0 }}>
        <strong style={{ display: 'block' }}>{t('affChanged.message')}</strong>
        <span style={{ fontSize: 13 }}>{t('affChanged.hint')}</span>
      </div>
      <AXButton variant="primary" onClick={() => window.location.reload()}>
        {t('affChanged.reload')}
      </AXButton>
    </div>
  );
}
